import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__Slot_js_7a50c2c6__ from "../Slot.js";
import * as __WEBPACK_EXTERNAL_MODULE__Link_module_js_628baf2b__ from "./Link.module.js";
const linkClass = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)(__WEBPACK_EXTERNAL_MODULE__Link_module_js_628baf2b__["default"].link);
function Link(props) {
    const { asChild } = props;
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__Slot_js_7a50c2c6__["default"] : 'a';
    const { children, href, target, className, ...linkProps } = props;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        ...asChild ? {} : {
            type: props.type ?? 'a'
        },
        href: href,
        rel: '_blank' === target ? 'noopener noreferrer' : void 0,
        className: linkClass({
            className
        }),
        ...linkProps,
        children: children
    });
}
export { Link as default };

//# sourceMappingURL=Link.js.map